import { Container, Typography, Paper } from '@mui/material'
import { Box, styled } from '@mui/system'
import QRCodeCanvas from 'qrcode.react'

export const Flex = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
})

export const CustomQRCode = styled(QRCodeCanvas)({
  margin: '50px'
})

export const StyledWalletAddress = styled(Typography)({
  overflowWrap: 'anywhere'
})

export const StyledPaper = styled(Paper)({
  padding: 40
})

export const StyledContainer = styled(Container)({
  marginTop: 60,
  paddingBottom: 60
})
